import { Link } from 'react-router-dom';

import CloudflareResponseImage from '~/components/CloudflareResponsiveImage/CloudflareResponseImage';
import { defaultSrcSetParams } from '~/components/CloudflareResponsiveImage/constants';
import { BannerMainCarousel } from '~/components/isolated/BannerMainCarousel';
import { useCategoryAnalytics } from '~/hooks/useCategoryAnalytics';
import { useGlobal } from '~/hooks/useGlobal';

import { createCategoryUrl } from '../shared/utils';

import styles from './BannerMainBlock.module.scss';
import type { BannerMainBlockProps } from './interfaces';

const BannerMainBlock = ({
  banners,
  priority,
  ...props
}: BannerMainBlockProps) => {
  const { isMobile } = useGlobal();
  const { handleClickCategory } = useCategoryAnalytics();

  if (!banners || banners.length === 0) {
    return null;
  }

  const items = banners.map(({ src, scrThumb, alt, linkId }, index) => ({
    id: linkId,
    node: (
      <Link
        data-link={`banner-${linkId}`}
        className={styles.link}
        onClick={handleClickCategory(linkId)}
        to={createCategoryUrl({ id: linkId })}
      >
        <CloudflareResponseImage
          alt={alt}
          className={styles.image}
          loading={priority && index === 0 ? 'eager' : 'lazy'}
          fetchPriority={priority && index === 0 ? 'high' : undefined}
          src={isMobile ? scrThumb || src : src}
          srcSetParams={defaultSrcSetParams}
        />
      </Link>
    ),
  }));

  return (
    <div className={styles.container}>
      <BannerMainCarousel {...props} items={items} />
    </div>
  );
};

export default BannerMainBlock;
